import React from 'react';
import './ScheduledCallsDisplay.css';

const ScheduledCallsDisplay = ({ scheduledCalls, onCallClick }) => {
  if (!scheduledCalls || scheduledCalls.length === 0) {
    return null;
  }

  return (
    <div className="scheduled-calls">
      <h4 className="scheduled-calls__title">
        Llamadas Programadas
      </h4>
      {scheduledCalls.map((call) => {
        const callDate = new Date(call.scheduledDate);
        const now = new Date();
        const isUpcoming = callDate > now;
        const canEdit = Boolean(onCallClick && call.id);

        return (
          <div
            key={call.id}
            className={`scheduled-calls__card ${canEdit ? 'scheduled-calls__card--clickable' : ''}`}
            onClick={canEdit ? () => onCallClick(call) : undefined}
          >
            <div className="scheduled-calls__card-row">
              <div className="scheduled-calls__card-main">
                <p className="scheduled-calls__card-date">
                  {callDate.toLocaleString('es-ES', {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
                {(call.notes || call.title) && (
                  <p className="scheduled-calls__card-notes">
                    {call.notes || call.title}
                  </p>
                )}
              </div>
              <div className="scheduled-calls__card-actions">
                {canEdit && (
                  <button
                    type="button"
                    className="scheduled-calls__btn-update"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCallClick(call);
                    }}
                  >
                    Actualizar
                  </button>
                )}
                {isUpcoming && call.meetingType === 'presential' && (
                  <span className="scheduled-calls__badge-presential">
                    Presencial
                  </span>
                )}
                {isUpcoming && call.meetingLink && (
                  <a
                    href={call.meetingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="scheduled-calls__link-join"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Unirse a Llamada
                  </a>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScheduledCallsDisplay;

